import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryPreview() {
  return (
    <section className="py-16 md:py-24 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            探索导航知识库
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            按照不同的主题分类，快速找到你需要的导航设计知识
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/60 hover:border-primary-300/50 transition-all duration-300 hover:translate-y-[-4px] flex flex-col items-center text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-50 text-primary-600 mb-4 group-hover:bg-primary-100 group-hover:scale-110 transition-all duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1.5">{cat.name}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">{cat.description}</p>
              <span className="text-xs text-primary-500 font-medium">
                {cat.articleCount} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}